// Page4Pictures.jsx - همراه با قابلیت برش (Crop) عکس با کادر ثابت و رفتار مشابه قالب فروشگاه
import React, { useState, useRef, useEffect } from "react";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { FiInfo, FiTrash2, FiStar } from "react-icons/fi";
import { FaStar } from "react-icons/fa"; // اضافه شدن ستاره توپر
import "./Page4Pictures.css";
import Swal from "sweetalert2";
import config from "../../../../config";

export default function Page4Pictures({
  onNext,
  onPrev,
  initialData,
  initialDeletedImages,
  onDataUpdate,
  onDeletedImagesUpdate,
  business_id
}) {
  const [images, setImages] = useState([]);
  const [deletedImages, setDeletedImages] = useState(initialDeletedImages || []);

  const [draggedImage, setDraggedImage] = useState(null);
  const [isCompressing, setIsCompressing] = useState(false);
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const fileInputRef = useRef(null);

  const [cropQueue, setCropQueue] = useState([]);
  const [cropper, setCropper] = useState(null);

  const generateUniqueId = () => {
    return Date.now() + Math.random().toString(36).substr(2, 9);
  };

  useEffect(() => {
    if (initialData) {
      let loadedImages = [];

      if (initialData.image_path || (initialData.gallery_path && Array.isArray(initialData.gallery_path))) {
        if (initialData.image_path) {
          const imageUrl = `${config.api.imageURL}/${initialData.image_path}`;
          loadedImages.push({
            id: generateUniqueId() + '-main',
            url: imageUrl,
            fileName: initialData.image_path.split('/').pop() || 'عکس اصلی',
            isMain: true,
            isNew: false,
            delete: false,
            fileSize: 0,
            order: 1
          });
        }

        if (initialData.gallery_path && Array.isArray(initialData.gallery_path)) {
          initialData.gallery_path.forEach((path, index) => {
            if (path) {
              const galleryUrl = `${config.api.imageURL}/${path}`;
              loadedImages.push({
                id: generateUniqueId() + `-gallery-${index}`,
                url: galleryUrl,
                fileName: path.split('/').pop() || `عکس گالری ${index + 1}`,
                isMain: false,
                isNew: false,
                delete: false,
                fileSize: 0,
                order: loadedImages.length + 1
              });
            }
          });
        }
      }
      else if (Array.isArray(initialData)) {
        loadedImages = initialData;
      } else if (initialData.images && Array.isArray(initialData.images)) {
        loadedImages = initialData.images;
      }

      if (loadedImages.length > 0) {
        const activeImages = loadedImages
          .filter(img => !img.delete)
          .map((img, idx) => ({
            ...img,
            url: img.url || img.path,
            fileName: img.fileName || 'عکس ذخیره شده',
            isNew: img.isNew || false,
            fileSize: img.fileSize || 0,
            order: idx + 1
          }));

        setImages(activeImages);
      }

      const previouslyDeleted = initialDeletedImages || initialData.deletedImages || [];
      setDeletedImages(previouslyDeleted);
    }
  }, [initialData, initialDeletedImages]);

  const updateParentData = (currentImages, currentDeletedImages = deletedImages) => {
    if (onDataUpdate) {
      const imagesData = {
        images: currentImages,
        deletedImages: currentDeletedImages,
        imagesCount: currentImages.length,
        deletedImagesCount: currentDeletedImages.length,
        mainImageIndex: currentImages.find(img => img.isMain)?.order || 1,
        mainImageId: currentImages.find(img => img.isMain)?.id,
        totalSize: currentImages.reduce((total, img) => total + img.fileSize, 0)
      };
      onDataUpdate(imagesData);
    }
    if (onDeletedImagesUpdate && currentDeletedImages !== deletedImages) {
      onDeletedImagesUpdate(currentDeletedImages);
    }
  };

  const compressToTargetSize = (file, targetSizeKB = 300) => {
    return new Promise((resolve) => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      const img = new Image();

      img.onload = async () => {
        let width = img.width;
        let height = img.height;
        const maxWidth = 1200;

        if (width > maxWidth) {
          height = Math.round((height * maxWidth) / width);
          width = maxWidth;
        }

        canvas.width = width;
        canvas.height = height;
        ctx.imageSmoothingQuality = 'high';

        let quality = 0.85;
        let blob = null;
        let attempts = 0;
        const maxAttempts = 6;

        while (attempts < maxAttempts) {
          ctx.clearRect(0, 0, width, height);
          ctx.drawImage(img, 0, 0, width, height);

          blob = await new Promise(res => {
            canvas.toBlob(res, 'image/jpeg', quality);
          });

          const currentSizeKB = Math.round(blob.size / 1024);

          if (currentSizeKB <= targetSizeKB || quality <= 0.4) {
            break;
          }
          quality -= 0.12;
          attempts++;
        }
        resolve(blob);
      };
      img.src = URL.createObjectURL(file);
    });
  };

  const getTargetSize = (fileSize, fileType) => {
    const sizeMB = fileSize / (1024 * 1024);
    if (fileType.includes('png')) {
      if (sizeMB > 3) return 400;
      if (sizeMB > 1) return 250;
      return 150;
    } else {
      if (sizeMB > 5) return 500;
      if (sizeMB > 2) return 350;
      if (sizeMB > 1) return 250;
      if (sizeMB > 0.5) return 180;
      return 120;
    }
  };

  const handleImageUpload = (event) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    if (images.length + cropQueue.length + files.length > 5) {
      alert(`فروشنده گرامی، شما حداکثر امکان ثبت ۵ تصویر (۱ تصویر اصلی و ۴ تصویر گالری) را دارید.\nدر حال حاضر ${images.length} تصویر ثبت شده و ${cropQueue.length} تصویر در صف برش است.`);
      event.target.value = '';
      return;
    }

    const validFiles = files.filter(file => {
      const isValidType = file.type.startsWith('image/');
      const isValidSize = file.size <= 20 * 1024 * 1024;
      return isValidType && isValidSize;
    });

    if (validFiles.length > 0) {
      setCropQueue(prev => [...prev, ...validFiles]);
    }
    event.target.value = '';
  };

  const confirmCrop = () => {
    if (typeof cropper !== "undefined" && cropQueue.length > 0) {
      setIsCompressing(true);
      const currentOriginalFile = cropQueue[0];

      cropper.getCroppedCanvas({
        width: 600,
        height: 800,
        fillColor: '#fff',
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      }).toBlob(async (blob) => {
        if (!blob) {
          setIsCompressing(false);
          return;
        }

        try {
          const croppedFile = new File([blob], currentOriginalFile.name, { type: 'image/jpeg' });
          let processedFile = croppedFile;

          if (croppedFile.size > 300 * 1024) {
            const targetSize = getTargetSize(croppedFile.size, croppedFile.type);
            const compressedBlob = await compressToTargetSize(croppedFile, targetSize);
            processedFile = new File([compressedBlob], currentOriginalFile.name, { type: 'image/jpeg' });
          }

          const base64Url = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = (e) => resolve(e.target.result);
            reader.readAsDataURL(processedFile);
          });

          const img = new Image();
          await new Promise((resolve) => {
            img.onload = resolve;
            img.src = base64Url;
          });

          const newImageObj = {
            id: generateUniqueId(),
            url: base64Url,
            file: processedFile,
            fileName: currentOriginalFile.name,
            fileSize: processedFile.size,
            fileType: processedFile.type,
            originalSize: currentOriginalFile.size,
            width: img.width,
            height: img.height,
            isMain: images.length === 0,
            order: images.length + 1,
            isNew: true,
            delete: false,
          };

          setImages(prev => {
            const updated = [...prev, newImageObj];
            const hasMain = updated.some(img => img.isMain);
            if (!hasMain && updated.length > 0) {
              updated[0].isMain = true;
            }
            const ordered = updated.map((item, index) => ({ ...item, order: index + 1 }));
            updateParentData(ordered);
            return ordered;
          });

        } catch (error) {
          console.error('❌ خطا در پردازش تصویر کراپ شده:', error);
          alert('خطایی در پردازش عکس رخ داد.');
        } finally {
          setIsCompressing(false);
          setCropQueue(prev => prev.slice(1));
        }
      }, 'image/jpeg', 0.9);
    }
  };

  const skipCrop = () => {
    setCropQueue(prev => prev.slice(1));
  };

  const cancelAllCrop = () => {
    setCropQueue([]);
  };

  const setAsMain = (id) => {
    setImages(prev => {
      const updatedImages = prev.map(img => ({
        ...img,
        isMain: img.id === id
      }));
      updateParentData(updatedImages);
      return updatedImages;
    });
  };

  const handleDragStart = (e, id) => {
    setDraggedImage(id);
    e.dataTransfer.effectAllowed = "move";
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    e.dataTransfer.dropEffect = "move";
  };
  const handleDrop = (e, targetId) => {
    e.preventDefault();
    if (!draggedImage || draggedImage === targetId) return;

    setImages(prev => {
      const draggedIndex = prev.findIndex(img => img.id === draggedImage);
      const targetIndex = prev.findIndex(img => img.id === targetId);

      if (draggedIndex === -1 || targetIndex === -1) return prev;

      const newImages = [...prev];
      const [draggedItem] = newImages.splice(draggedIndex, 1);
      newImages.splice(targetIndex, 0, draggedItem);

      const reorderedImages = newImages.map((img, index) => ({
        ...img,
        order: index + 1
      }));

      updateParentData(reorderedImages);
      return reorderedImages;
    });
    setDraggedImage(null);
  };

  const removeImage = (id) => {
    setImages(prev => {
      const imageToRemove = prev.find(img => img.id === id);
      if (!imageToRemove) return prev;

      let updatedImages;
      let updatedDeletedImages = [...deletedImages];

      if (business_id && imageToRemove && !imageToRemove.isNew) {
        updatedDeletedImages.push({ ...imageToRemove, delete: true });
        setDeletedImages(updatedDeletedImages);
        updatedImages = prev.filter(img => img.id !== id);
      } else {
        updatedImages = prev.filter(img => img.id !== id);
      }

      const wasMain = imageToRemove?.isMain;
      if (wasMain && updatedImages.length > 0) {
        updatedImages[0].isMain = true;
      }

      const reorderedImages = updatedImages.map((img, index) => ({
        ...img,
        order: index + 1
      }));

      updateParentData(reorderedImages, updatedDeletedImages);
      return reorderedImages;
    });
  };

  const handleAddMoreImages = () => {
    fileInputRef.current?.click();
  };

  const handleSubmit = () => {
    const finalData = {
      images: images,
      deletedImages: deletedImages,
      imagesCount: images.length,
      deletedImagesCount: deletedImages.length,
      mainImageIndex: images.find(img => img.isMain)?.order || 1,
      mainImageId: images.find(img => img.isMain)?.id,
      totalSize: images.reduce((total, img) => total + img.fileSize, 0)
    };
    onNext(finalData);
  };

  return (
    <div className="p4-container" dir="rtl">

      {/* ✂️ مودال استاندارد و کوچکتر کراپ عکس */}
      {cropQueue.length > 0 && (
        <div className="p4-image-dialog-overlay" style={{ zIndex: 9999 }}>
          <div className="p4-image-dialog-content" style={{ maxWidth: '500px', width: '90%' }}>
            <div className="p4-dialog-header">
              <h3 style={{ fontSize: '15px' }}>تنظیم تصویر ({cropQueue.length} در صف)</h3>
              <button className="p4-dialog-close" onClick={cancelAllCrop}>✕</button>
            </div>

            <div style={{ width: "100%", height: "400px", background: "#f0f0f0", marginBottom: "15px" }}>
              <Cropper
                src={URL.createObjectURL(cropQueue[0])}
                style={{ height: "100%", width: "100%" }}
                onInitialized={(instance) => setCropper(instance)}
                aspectRatio={600 / 800}
                viewMode={3}
                dragMode="move"
                cropBoxMovable={false}
                cropBoxResizable={false}
                zoomable={true}
                autoCropArea={1}
                minCropBoxWidth={225}
                minCropBoxHeight={300}
                background={false}
                responsive={true}
                checkOrientation={false}
              />
            </div>

            <div style={{ display: 'flex', gap: '8px', justifyContent: 'center', padding: '10px 0' }}>
              <button
                onClick={confirmCrop}
                disabled={isCompressing}
                style={{ background: '#4CAF50', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px' }}>
                {isCompressing ? 'پردازش...' : 'تایید و برش ✂️'}
              </button>
              <button
                onClick={skipCrop}
                disabled={isCompressing}
                style={{ background: '#ff9800', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px' }}>
                رد کردن
              </button>
              <button
                onClick={cancelAllCrop}
                disabled={isCompressing}
                style={{ background: '#f44336', color: 'white', padding: '8px 15px', border: 'none', borderRadius: '5px', cursor: 'pointer', fontSize: '13px' }}>
                لغو همه
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="p4-upload-section">
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          multiple
          onChange={handleImageUpload}
          className="p4-file-input-hidden"
          disabled={isCompressing || cropQueue.length > 0}
        />

        <div className="p4-add-more-section">
          <button
            className="p4-add-more-btn"
            onClick={handleAddMoreImages}
            disabled={isCompressing || cropQueue.length > 0}
          >
            <span className="p4-add-more-icon">
              {isCompressing ? "⏳" : "+"}
            </span>
            {isCompressing
              ? "در حال پردازش..."
              : images.length === 0
                ? "افزودن عکس"
                : "افزودن عکس بیشتر"}
          </button>

          <button
            className={`p4-help-icon-btn ${isHelpOpen ? 'active' : ''}`}
            onClick={() => setIsHelpOpen(!isHelpOpen)}
            title="راهنمای تصاویر"
          >
            <FiInfo size={24} />
          </button>
        </div>

        {/* کشوی راهنما */}
        <div className={`p4-help-box ${isHelpOpen ? 'open' : ''}`}>
          <p className="p4-info">
            • شما می‌توانید حداکثر ۵ تصویر (۱ اصلی و ۴ گالری) برای محصول انتخاب کنید.<br />
            • برای تغییر ترتیب عکس‌ها، آن‌ها را با ماوس کشیده و جابجا کنید (Drag & Drop).<br />
            • سیستم به طور خودکار حجم و ابعاد تصاویر را برای نمایش بهتر بهینه می‌کند.<br />
          </p>
        </div>
      </div>

      <div className="p4-images-grid">
        {images.length === 0 ? (
          <div className="p4-empty-state">
            <div className="p4-empty-icon">🖼️</div>
            <h3 className="p4-empty-title">هنوز عکسی اضافه نکرده‌اید</h3>
            <p className="p4-empty-desc">
              عکس‌های محصول خود را آپلود کنید - سیستم به طور خودکار آن‌ها را بهینه می‌کند
            </p>
          </div>
        ) : (
          images.map((image) => (
            <div
              key={image.id}
              className={`p4-image-card ${image.isMain ? 'p4-main-image' : ''}`}
              draggable={!isCompressing}
              onDragStart={(e) => handleDragStart(e, image.id)}
              onDragOver={handleDragOver}
              onDrop={(e) => handleDrop(e, image.id)}
            >
              {image.originalSize > image.fileSize && (
                <div className="p4-compression-badge">
                  🔥 {Math.round((1 - (image.fileSize / image.originalSize)) * 100)}%
                </div>
              )}
              <div className="p4-image-header">
                <button
                  className="p4-delete-icon-btn"
                  onClick={(e) => { e.stopPropagation(); removeImage(image.id); }}
                  title="حذف این عکس"
                  disabled={isCompressing}
                >
                  <FiTrash2 size={16} />
                </button>
                <div className="p4-header-actions">
                  <button
                    className="p4-star-btn"
                    onClick={() => setAsMain(image.id)}
                    title={image.isMain ? "عکس اصلی" : "انتخاب به عنوان عکس اصلی"}
                  >
                    {image.isMain ? <FaStar size={18} color="#f59e0b" /> : <FiStar size={18} color="#9ca3af" />}
                  </button>
                </div>
              </div>
              <div className="p4-image-content">
                <img
                  src={image.url}
                  alt={`محصول`}
                  className="p4-image"
                  loading="lazy"
                  onError={(e) => { e.target.src = process.env.PUBLIC_URL + '/images/default-image.jpg' }}
                />
              </div>
            </div>
          ))
        )}
      </div>

      <div className="p4-button-wrapper">
        <button className="p4-prev-btn" onClick={onPrev} disabled={isCompressing || cropQueue.length > 0}><span className="p4-btn-icon">→</span>مرحله قبل</button>
        <button className="p4-next-btn" onClick={handleSubmit} disabled={isCompressing || cropQueue.length > 0}>{isCompressing ? "⏳ در حال پردازش..." : "مرحله بعد"}<span className="p4-btn-icon">←</span></button>
      </div>
    </div>
  );
}
